<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Notas de Serviço dos Clientes</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{ countFilter }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Notas de serviço</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 v-if="pagination.TotalItems > 0" class="m-0">
                    {{ pagination.TotalItems | number }} {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0" v-if="pagination.TotalItems > 1">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div class="dropdown-menu" id="dropTableOptions" aria-labelledby="dropdownMenuButton">
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader :small="true" :isLoading="loadingReport"></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Cliente</th>
                    <th scope="col" class="border-0">Número da nota</th>
                    <th scope="col" class="border-0">Número RPS</th>
                    <th scope="col" class="border-0 text-left">Status</th>
                    <th scope="col" class="border-0">Valor</th>
                    <th scope="col" class="border-0">Data de emissão</th>
                    <th scope="col" class="border-0">Período</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(noteExtract, index) in noteExtracts" :key="index">
                    <td></td>
                    <td class="text-left">{{ noteExtract.Merchant.Name }}</td>
                    <td>{{ noteExtract.NFSeNumber }}</td>
                    <td>{{ noteExtract.RPSNumber }}</td>
                    <td class="text-left">{{ noteExtract.StatusNFSe }}</td>
                    <td class="same-line">{{ noteExtract.Amount | currency }}</td>
                    <td>{{ noteExtract.EmissionDate | date }}</td>
                    <td>{{ noteExtract.Period | monthYear }}</td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a
                            class="dropdown-item"
                            href="#"
                            :class="loadingPdf ? 'disabled' : ''"
                            v-on:click.stop="PDFNoteExtract(noteExtract.Id, noteExtract.Merchant.Id)"
                          >
                            <template v-if="loadingPdf">
                              <loader :small="true" :isLoading="loadingPdf"></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-file-pdf mr-2"></i>
                              Download PDF
                            </template>
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            :class="loadingXml ? 'disabled' : ''"
                            v-on:click.stop="XMLNoteExtract(noteExtract.Id, noteExtract.Merchant.Id)"
                          >
                            <template v-if="loadingXml">
                              <loader :small="true" :isLoading="loadingXml"></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-file-alt mr-2"></i>
                              Download XML
                            </template>
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="noteExtracts == null || noteExtracts == undefined || noteExtracts.length == 0">
                    <td colspan="9">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="mFilter" title="Filtros" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            placeholder="Cliente"
            type="text"
            class="form-control"
            v-model="filter.NameMerchant"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <input
            placeholder="Status"
            type="text"
            class="form-control"
            v-model="filter.StatusNFSe"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="12" class="form-group">
          <date-field v-model="filter.Period" format="MMMM yyyy" minimumView="month"></date-field>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button variant="primary" class="btn btn-primary" v-b-tooltip.hover.bottom title="Pesquisar" @click="Filter()">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import dateField from "@/components/common/date-field";
export default {
  name: "note-extracts",
  data: function() {
    return {
      countFilter: 0,
      filter: {
        NameMerchant: null,
        Period: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
        StatusNFSe: null
      },
      loadingList: false,
      loadingPdf: false,
      loadingReport: false,
      loadingXml: false,
      noteExtracts: [],
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      }
    };
  },
  components: {
    dateField
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function() {
      this.ListNoteExtract();
    },
    "pagination.RowsPerPage": function() {
      this.ListNoteExtract();
    }
  },
  mounted() {
    this.ListNoteExtract();
  },
  methods: {
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.ListNoteExtract();
    },
    GetReport: function(ev) {
      ev.preventDefault();
      this.loadingReport = true;

      let date = new Date(this.filter.Period);
      let initialDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), 1);
      let endDate = new Date(date.getUTCFullYear(), date.getUTCMonth() + 1, 0);
      const params = {
        EndDate: this.$options.filters.date(endDate, "YYYY-MM-DD"),
        InitialDate: this.$options.filters.date(initialDate, "YYYY-MM-DD"),
        "Object.Merchant.Name": this.filter.NameMerchant,
        "Object.StatusNFSe": this.filter.StatusNFSe
      };

      this.$store
        .dispatch("ReportNoteExtractMerchant", { params: params })
        .then(response => {
          if (response.UrlReport != null && response.UrlReport != undefined && response.UrlReport != "") {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast("Tente novamente mais tarde.", "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    ResetFilter: function() {
      this.filter = {
        NameMerchant: null,
        StatusNFSe: null,
        Period: this.$options.filters.date(new Date(), "YYYY-MM-DD")
      };
      this.ListNoteExtract();
    },
    ListNoteExtract: function() {
      this.countFilter = 0;
      if (hasValue(this.filter.Period)) this.countFilter++;
      if (hasValue(this.filter.NameMerchant)) this.countFilter++;
      if (hasValue(this.filter.StatusNFSe)) this.countFilter++;
      this.loadingList = true;
      let date = new Date(this.filter.Period);
      let initialDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), 1);
      let endDate = new Date(date.getUTCFullYear(), date.getUTCMonth() + 1, 0);
      let data = {
        ...this.pagination,
        ...{
          "Object.Merchant.Name": this.filter.NameMerchant,
          "Object.StatusNFSe": this.filter.StatusNFSe,
          InitialDate: this.$options.filters.date(initialDate, "YYYY-MM-DD"),
          EndDate: this.$options.filters.date(endDate, "YYYY-MM-DD")
        }
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListNoteExtract", { params: data })
        .then(
          response => {
            this.noteExtracts = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          },
          error => {
            this.$makeToast("Não foi possível listar as notas", "danger", "Notas de serviço", error);
          }
        )
        .finally(() => {
          this.loadingList = false;
        });
    },
    PDFNoteExtract: function(id, idMerchant) {
      this.loadingPdf = true;
      const params = {
        id: id,
        idMerchant: idMerchant
      };
      this.$store
        .dispatch("PDFNoteExtract", { params: params })
        .then(response => {
          if (hasValue(response)) {
            this.$makeToast("Aguarde a conclusão do download", "info", "PDF gerado com sucesso");
            this.DownloadPdfXml(response[1], response[0]);
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o PDF", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingPdf = false;
          }, 1200);
        });
    },
    XMLNoteExtract: function(id, idMerchant) {
      this.loadingXml = true;
      const params = {
        id: id,
        idMerchant: idMerchant
      };
      this.$store
        .dispatch("XMLNoteExtract", { params: params })
        .then(response => {
          if (hasValue(response)) {
            this.$makeToast("Aguarde a conclusão do download", "info", "XML gerado com sucesso");
            this.DownloadPdfXml(response[1], response[0]);
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o XML", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingXml = false;
          }, 1200);
        });
    },
    
    DownloadPdfXml(filename, text) {
      const arq = filename.split(".").pop();
      const type = arq == "xml" ? "text/plain;charset=utf-8," : "application/pdf;base64,";

      const element = document.createElement("a");

      element.setAttribute("href", "data:" + type + encodeURIComponent(text));
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }
  }
};
</script>
<style lang="scss" scoped>
.same-line {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/NoteExtracts.vue